import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer>
            <a href="/" className="footer-logo">
                <div className="footer-logo-mark">
                    <svg viewBox="0 0 24 24" fill="none" stroke="#60A5FA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="3"/>
                        <path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12"/>
                    </svg>
                </div>
                <span className="footer-logo-text">AIColl</span>
            </a>

            <span className="footer-copy">&copy; 2026 AIColl. Все права защищены.</span>

            <div className="footer-links">
                <a href="mailto:info@aicoll.ru">info@aicoll.ru</a>
                <a href="/app.html">Войти в приложение</a>
            </div>
        </footer>
    );
}

export default Footer;